import React, {Component} from 'react'
import locale from '../locale'
import { Table } from 'components/UI'
import moment from 'moment'
import Loading from 'components/UI/Loading'
import updateClassStudentState from 'controllers/class/updateClassStudentState'
import {confirm} from 'util/confirm'
import { connect } from 'react-redux';
import __R, { userCan } from 'containers/__R'
import PaymentModal, { REFUND } from 'template/Modals/NewPayment';
import CreateClassModal from 'template/Modals/CreateClass'
import CreateClassOneModal from 'template/Modals/CreateClassOne'
import Tooltip from 'react-tooltip';

const mapStateToProps = (state) => ({
  user: state.user,
})

class currentClassTable extends Component{
  constructor(props){
    super(props)

    this.state = {
      classList: [],
      fetching: true
    }
  }

  componentWillReceiveProps({classList}){
    if(classList){
      this.setState({classList: classList, fetching: false})
    }
  }
  render(){
    const {showTable, student, getClassList, checkStudentUpdate} = this.props
    let {classList, fetching} = this.state

    const fields = [{
      name: 'className',
      title: __('Class', locale),
      getTdProps: ({tbodyData}) => {
        return {
          style: {
            width: "35%"
          }
        }
      },
    }, {
      name: 'total_counted_amount',
      title: __('Attended', locale),
      getTdProps: ({tbodyData}) => {
        return {
          style: {
            width: "10%"
          }
        }
      },
      getTdContent: ({ trData: classInfo }) => {
        return classInfo.check_in_statistics.total_counted_amount
      },
    }, {
      name: 'total_absent_amount',
      title: __('Unattended', locale),
      getTdProps: ({tbodyData}) => {
        return {
          style: {
            width: "10%"
          }
        }
      },
      getTdContent: ({ trData: classInfo }) => {
        return classInfo.check_in_statistics.total_absent_amount
      },
    }, {
      name: 'class status',
      title: __('Class Status', locale),
      getTdProps: ({tbodyData}) => {
        return {
          style: {
            width: "20%"
          }
        }
      },
      getTdContent: ({ trData: classInfo }) => {
        if(classInfo.feeType == 0){
          return classInfo.consumed_and_purchased.paidEndDate ? moment(classInfo.consumed_and_purchased.paidEndDate).format(__('MMM DD, YYYY', locale)) : ''
        } else if(classInfo.feeType == 1){
          return classInfo.consumed_and_purchased.usedTotalQuantity + '/' + classInfo.consumed_and_purchased.paidTotalQuantity + ' ' + __('', locale)
        } else if(classInfo.feeType == 2){
          return classInfo.consumed_and_purchased.usedTotalQuantity + '/' + classInfo.consumed_and_purchased.paidTotalQuantity + ' ' + __('Hour', locale)
        }
      },
    },{
      name: 'tuition_consumption',
      title: __('Used/Paid', locale),
      getTdProps: ({tbodyData}) => {
        return {
          style: {
            width: "20%"
          }
        }
      },
      getTdContent: ({ trData: classInfo }) => {
        const currency = this.props.schoolDetail.currency
        const tuition_consumption = classInfo.consumed_and_purchased.tuition_consumption
        const paidTotalFee = classInfo.consumed_and_purchased.paidTotalFee
        const discountAmount = classInfo.consumed_and_purchased.total_discount_amount

        if(classInfo && tuition_consumption !== null){
          if(discountAmount > 0){
            return(
              <div>
                {tuition_consumption + ' / ' + paidTotalFee + ' ' +  currency}
                <i className='fa icon-tag' data-tip data-for={toString(classInfo.classID)}></i>
                <Tooltip
                  id={toString(classInfo.classID)}
                  effect='solid'
                  place='bottom'
                  type='info'
                  getContent={()=> { return __('Discounted', locale) + ' ' + discountAmount + ' ' + currency; }}
                />
              </div>
            )
          } else {
            return(
              <div>{tuition_consumption + ' / ' + paidTotalFee + ' ' +  currency}</div>
            )
          }
        } else if (_.isEmpty(classInfo)) {
          return (<div />)
        } else {
          return (<div style={{cursor: 'pointer'}} onClick={() => {
            if(classInfo.class_type == 0){
              CreateClassModal({mode: 'update', id: classInfo.classID})
              .then(() => {
                getClassList();
              })
            } else {
              CreateClassOneModal({mode: 'update', id: data.classInfo.classID})
              .then(() => {
                getClassList();
              })
            }
          }}>{__('Setup', locale)}</div>)
        }
      },
    }]

    let dropdown = [
      {
        title: __('Payment', locale),
        onClick: ({ trData: classInfo }) => {
          let user_id = this.props.user.result.user_id;
          PaymentModal({student, user_id})
            .then(()=>{
              checkStudentUpdate(true)
            })
        },
        isDisabled: (opts) => {
          return !userCan('student_charge')
        }
      },
      {
        title: __('Exit Class', locale),
        onClick: ({ trData: classInfo }) => {
          const {studentId} = this.props

          if(classInfo.consumed_and_purchased.paidTotalFee > 0){
            confirm(__('This student has paid tuition, do you wish to refund?', 'studentTable'))
            .then(() => {
              PaymentModal({
                student,
                classInfo,
                user_id: this.props.user.result.user_id,
                paymentType: REFUND,
                confirmTitle: __('Refund & Exit Class', 'classdetail'),
                confirmText: __('Proceed to refund and remove the student, {student_name}, from class?', 'classdetail', { student_name: student.sName }),
              })
              .then(() => {
                confirm(__('Proceed to exit class?', locale))
                .then(() => {
                  this.setState({fetching: true})
                  updateClassStudentState(classInfo.classID, Number(studentId),'not_enrolled')
                  .then((res) => {
                    this.setState({fetching: false})
                    checkStudentUpdate(true)
                    getClassList();
                  })
                })
              })
              .catch(() => {})
            })
            .catch(() => {
              confirm(__('Proceed to exit class?', locale))
              .then(() => {
                this.setState({fetching: true})
                updateClassStudentState(classInfo.classID, Number(studentId),'not_enrolled')
                .then((res) => {
                  this.setState({fetching: false})
                  checkStudentUpdate(true)
                  getClassList();
                })
              })
              .catch(() => {})
            })
          } else {
            confirm(__('Proceed to exit class?', locale))
            .then(() => {
              this.setState({fetching: true})
              updateClassStudentState(classInfo.classID, Number(studentId),'not_enrolled')
              .then((res) => {
                this.setState({fetching: false})
                checkStudentUpdate(true)
                getClassList();
              })
            })
            .catch(() => {})
          }
        },
        isDisabled: (opts) => {
          return !userCan('archive_student_from_class')
        }
      },
    ];

    const settings = [
      {
        title: <i className='fa icon-ellipsis-vert'></i>,
        id: "client-dropdown",
        dropdown
      },
    ]

    if(showTable){
      return(
        <Table
          data={classList}
          fields={fields}
          className='currentClassTable'
          settingThTitle={' '}
          settingWidth={'15%'}
          settings={settings}
          useMultiSelection={false}
          oneSettingPerRow={false}
          usePagination={false}
          hideDropdownCaret={true}
          fetching={fetching}
          dropdownGuideWidth={160}
          dropdownGuideHeight={228}
        />
      )
    } else {
      return(
        <div />
      )
    }
  }
}


export default connect(mapStateToProps)(currentClassTable)



// WEBPACK FOOTER //
// ./src/template/Docks/StudentInfo/Tables/currentClassTable.js